import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Tabs, Script } from '../../../components';
import { MessageBox } from '../../../components/MessageBox';

const InnerWrapper = styled.div`
  flex: 1;
  max-height: 380px;
  overflow: auto;
  padding: 16px;
`;

function Scenario({ task }) {
  const [activeIndex, setActiveIndex] = useState(0);

  let agentName = 'Agent';
  let workerName = 'Worker';
  let scripts = [];
  let group = '';
  let topic = '';

  if (task) {
    if (task.taskInput) {
      const taskInput = JSON.parse(task.taskInput);

      agentName = taskInput.agent;
      workerName = taskInput.worker;
      scripts = taskInput.prompts;
      ({ topic, group } = taskInput);
    }
  }

  return (
    <Tabs activeIndex={activeIndex} onTabChange={setActiveIndex}>
      <Tabs.Tab title="Scenario">
        <InnerWrapper>
          <MessageBox group={group} topic={topic} />
          {scripts.map((script, index) => (
            <Script
              customer={script.type !== 'agent'}
              // the array provided doesn't have any ids, disabling eslint
              // eslint-disable-next-line react/no-array-index-key
              key={`script-${index}`}
              user={script.type === 'agent' ? agentName : workerName}
            >
              {script.label}
            </Script>
          ))}
        </InnerWrapper>
      </Tabs.Tab>

      <Tabs.Tab title="Instructions">
        <InnerWrapper>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: task.jobInstructions }} />
        </InnerWrapper>
      </Tabs.Tab>
    </Tabs>
  );
}

Scenario.propTypes = {
  task: PropTypes.shape({
    jobCall: PropTypes.string,
    taskId: PropTypes.string,
    callId: PropTypes.string,
    taskInput: PropTypes.string
  })
};

Scenario.defaultProps = {
  task: {}
};

export default connect(({ tasks, call }) => ({
  task: {
    ...tasks.currentTask.task,
    callId: call.callId
  }
}))(Scenario);
